import Vue from 'vue'
import Router from 'vue-router'
import Main from 'pages/Main'
import home from 'pages/home/home'
import category from 'pages/category/category'
import cart from 'pages/cart/cart'
import my from 'pages/my/my'
import detail from 'pages/detail/detail'
import pay from 'pages/pay/pay'
import paysuc from 'pages/pay/pay_suc'
import submit_pay from 'pages/pay/submit_pay'
import orderList from 'pages/my/orderList'
import aboutBill from 'pages/bill/aboutBill'
import billmsg from 'pages/bill/billmsg'
import bookmark from 'pages/bookmark/bookmark'
import home_search from 'pages/search/home_search'
import listDetail from 'pages/my/listDetail'
import addressList from 'pages/address/addressList'
import addAddress from 'pages/address/addAddress'
import addressTest from 'pages/address/addressTest'



Vue.use(Router)

export default new Router({
  linkActiveClass: 'cur',
  routes: [
    //默认重定向
    {
      path: '/',
      //name: 'Main',
      meta: {
        title: '淘你喜欢'
      },
      component: home,
    }, {
      path: '/home',
      //name: 'Main',
      meta: {
        title: '淘你喜欢'
      },
      component: home,
    },
    {
      path: '/my',
      name: 'my',
      meta: {
        title: '我的'
      },
      component: my
    },
    {
      path: '/cart',
      name: 'cart',
      meta: {
        title: '购物车'
      },
      component: cart
    },
    {
      path: '/detail/:id',
      name: 'detail',
      meta: {
        title: '商品详情'
      },
      component: detail,
      // redirect: '/detail/:itemId',//使用重定向
    },
    {
      path: '/pay/:isDetailOrCart', //0 detail  1 cart
      name: '/pay',
      meta: {
        title: '填写订单'
      },
      component: pay
    }, {
      path: '/paysuc/:payway/:money',
      name: '/paysuc',
      meta: {
        title: '支付成功'
      },
      component: paysuc
    },
    {
      path: '/submit_pay/:money',
      name: 'submit_pay',
      meta: {
        title: '支付订单'
      },
      component: submit_pay
    },
    {
      path: '/orderList',
      name: '/orderList',
      meta: {
        title: '我的订单'
      },
      component: orderList
    },
    {
      path: '/aboutBill',
      name: '/aboutBill',
      meta: {
        title: '关于发票'
      },
      component: aboutBill
    },
    {
      path: '/billmsg',
      name: '/billmsg',
      meta: {
        title: '发票信息'
      },
      component: billmsg
    },
    {
      path: '/bookmark',
      name: 'bookmark',
      meta: {
        title: '收藏夹'
      },
      component: bookmark
    },
    {
      path: '/home_search',
      name: '/home_search',
      component: home_search,
      meta: {
        title: '搜索商品'
      },
    },
    {
      path: '/listDetail/:kid/:whichList/:isWaitGoods', //whichList 区分使用哪个查询数组
      name: 'listDetail',
      component: listDetail
    },
    {
      path: '/addressList',
      name: 'addressList',
      meta: {
        title: '我的收货地址'
      },
      component: addressList
    },
    {
      path: '/addAddress/:isUpdate/:isCardAdd', //0新增、1修改
      name: 'addAddress',
      meta: {
        title: '收货地址的编辑'
      },
      component: addAddress
    },
    {
      path: 'addressTest', //0新增、1修改
      name: 'addressTest',
      component: addressTest
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js